/**
 * Created by baladewa on 5/20/16.
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('trainingPairingComponent', {
            templateUrl: 'create-pairing/components/training-pairing-component.tpl.html',
            controller: function (EventManagerService, CommonMasterData, MessageService, CreatePairing,$timeout) {
                var vm = this, dataArrayForFilters=[],locFilter='', catFilter='';
                var trainingWidth = 80;
                vm.trainingWidth = trainingWidth;
                vm.hourCols = {};
                vm.timeLineData = [];
                vm.dayLineData = [];
                vm.trainingData = null;
                vm.filteredData = null;
                vm.da_start = null;
                vm.popover = null;
                vm.scrollAreaWidth = 0;
                vm.locationList = [];
                vm.categoryList = [];
                vm.categoryIndexPosition = {};
                vm.categoryPositionIndex = [];
                vm.minimumTopPosition = null;
                vm.rest = "false";
                vm.viewMode = 'D';
                //vm.showInCrewPortal = null;

              vm.rowBlock=[];
              //vm.filteredData = [];
              vm.displayPairing = false;
              vm.fixedTopHeader = false;
              vm.selectedDate = "";
              vm.fromDate = "";

              var min_screen_width = 1200;
              vm.screen_left_panel = 100;
              vm.screen_right_panel = 0;
              vm.comHeight = window.innerHeight - (70 + 42 + 40 + 80);
              vm.toolTipModel = {
                origin:null,
                destination:null,
                departureTime:null,
                arrivalTime:null,
                flightNumber:null
              };
              vm.isElasticLoadingVisible = false;
              vm.displayParams = {
                no_of_actual_hour_cols_per_day : 24,
                no_of_actual_day_cols_per_week: 7,
                no_actual_day_cols_per_month : 30,
                no_of_hour_cols_per_day : 26,
                no_day_cols_per_week : 7,
                no_day_cols_per_month : 32,
                no_week_cols_per_month : 4
              };

              vm.timeLineData = [];
              vm.dayLineData = [];

              vm.minimum_number_of_columns = vm.displayParams.no_of_hour_cols_per_day;
              vm.actual_number_of_coulmns = 0;
              if (vm.viewMode == 'W') {
                vm.minimum_number_of_columns = vm.displayParams.no_day_cols_per_week;
              }
              if (vm.viewMode == 'M') {
                vm.minimum_number_of_columns = vm.displayParams.no_day_cols_per_month;
              }

              vm.actual_screen_width = window.innerWidth;

              if (!!vm.actual_screen_width && vm.actual_screen_width > min_screen_width) {
                vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel;
              }

              vm.scrollAreaWidth = vm.actual_screen_width;

              EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.TRAINING_DATA_CHANGE, function(data){
                    vm.trainingData = data;
                    vm.categoryIndexPosition =  [];
                    dataArrayForFilters = vm.trainingData;
                    setLocationList();
                    setCategoryList();
                    renderTimeLine();
                    filterDataByCategory();

                });

                vm.closePopover = function(event){
                    $timeout(function(){
                        angular.element('html').trigger('click');
                    },0);
                };

                vm.onClickTraining = function(training){
                    if(!!vm.popover){
                        angular.element('html').trigger('click');
                    }
                    vm.popover = training;

                    CommonMasterData.getTrainingProgram(training,
                        function (programsResults) {
                            vm.programs = programsResults;
                            setTrainingProgram(training);
                        },
                        function (error) {
                            MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
                        }
                    );
                };

                vm.onChangeProgram = function(selectedItem,training){
                    if(!!selectedItem){
                        vm.popover.trainingProgramId = selectedItem.trainingProgramId;
                        CommonMasterData.getTrainingProgramDetails(selectedItem,
                            function (programDetailsResults) {
                                vm.programDetails = programDetailsResults;
                                if(!!training && training.trainingProgramDetailCode !== null){
                                  setTrainingProgramDetail(training.trainingProgramDetailCode);
                                }
                            },
                            function (error) {
                                MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
                            }
                        );
                    }
                };

                function setTrainingProgram(training){
                  if(!!training.trainingProgramDesc && training.trainingProgramDesc!== null){
                    var prgList = _.filter(vm.programs ,function(prog){return training.trainingProgramDesc === prog.trainingProgramCode});
                    vm.popover.trainingProgram = prgList[0];
                    vm.onChangeProgram(vm.popover.trainingProgram,training);
                  }
                }

                function setTrainingProgramDetail(trainingProgramDetailCode) {
                  var prgDetList = _.filter(vm.programDetails ,function(prog){return trainingProgramDetailCode === prog.trainingProgDetailCode});
                  vm.popover.trainingProgramDetail = prgDetList[0];
                }

                vm.onSelectLocation = function(){
                    dataArrayForFilters = vm.trainingData;
                    if(vm.selectedLocation!==undefined){
                        locFilter = vm.selectedLocation.location;
                    }else{
                        locFilter = '';
                    }
                    setCategoryList();
                    filterDataByCategory();
                };

                vm.onSelectCategory = function(){
                    if(vm.selectedCategory!==undefined) {
                        catFilter = vm.selectedCategory.category;
                        /*var catList = _.groupBy(dataArrayForFilters, 'trainingProCategory');
                        var dataItem = vm.selectedCategory.category;
                        dataArrayForFilters = catList[dataItem];*/
                    }else{
                        catFilter = '';
                    }
                    filterDataByCategory();
                };

                vm.onChangeProgramDetail = function(selectedItem){
                    if (selectedItem!==undefined){
                        vm.popover.trainingProgramDetailId = selectedItem.trainingProgramDetailId;
                    }
                };

                vm.onAddTrainingClick = function(training){
                  var rest = ((vm.rest === "true") ? true : false);

                    if(!training.trainingProgram){
                        MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.TRAINING_ERROR_01);
                        return;
                    }
                    else if(!training.trainingProgramDetail){
                        MessageService.error(MessageService.MESSAGES.CREATE_PAIRING.TRAINING_ERROR_02);
                        return;
                    }
                    else{
                        var option = {
                            selectedTraining:training,
                            isRestRequired: rest
                        };
                        vm.onAddTraining(option)

                        var rest ={
                          isRestRequired: vm.rest
                        }
                      vm.isRestRequired(rest);
                    }
                    vm.closePopover();
                };

              vm.onBlockHover = function (e, block) {
                vm.blockToolTiop = block;
                var findCheckPosition = function () {
                  var H = 'left', V = 'top';
                  if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                    H = 'left';
                  } else {
                    H = 'right';
                  }
                  if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                    V = 'bottom';
                  } else {
                    V = 'top';
                  }
                  return H + '-' + V;
                };

                vm.toolTipPosition = findCheckPosition();
              };

                function getFilteredData(){
                    if (locFilter!==''){
                        var locList = _.groupBy(vm.trainingData, 'trainingLocCode');
                        dataArrayForFilters = locList[locFilter];
                    }else{
                        dataArrayForFilters = vm.trainingData;
                    }
                    if (catFilter!==''){
                        var catList = _.groupBy(dataArrayForFilters, 'trainingProCategory');
                        dataArrayForFilters = catList[catFilter];
                    }
                    return dataArrayForFilters.map(function(obj) {
                      return Object.assign({}, obj, {catHubFilter: obj.crewHub + " - " + obj.trainingProCategory});
                    })
                }

                function setCategoryList(){
                    vm.categoryList = [];
                    var catList = _.groupBy(dataArrayForFilters, 'trainingProCategory');
                    angular.forEach(catList, function(arr, key){
                        vm.categoryList.push({
                            category:key,
                            categoryData:arr
                        })
                    });
                }

                function setLocationList(){
                    vm.locationList = [];
                    var locList = _.groupBy(vm.trainingData, 'trainingLocCode');
                    angular.forEach(locList, function(arr, key){
                        vm.locationList.push({
                            location:key,
                            locationDate:arr
                        })
                    });
                }

                function formatTraining(trainingArr){
                    var toSend =[];
                    var catColorMap = CreatePairing.TRAINING_COLOR_MAP;
                    var index =  0;
                    var prevTraining;

                    angular.forEach(trainingArr, function(training) {
                      var temp = training;

                      console.log(vm.minuteToPixelRatio);
                      temp.height = (getTimeInMinFromStartDate(training.endDateZulu, training.endTimeZulu) - getTimeInMinFromStartDate(training.startDateZulu, training.startTimeZulu));
                      console.log(getTimeInMinFromStartDate(training.endDateZulu, training.endTimeZulu) - getTimeInMinFromStartDate(training.startDateZulu, training.startTimeZulu));
                      temp.topPos = getTimeInMinFromStartDate(training.startDateZulu, training.startTimeZulu);
                      console.log(getTimeInMinFromStartDate(training.startDateZulu, training.startTimeZulu));
                      temp.bgColor = training.usedInCurrentPattern ? "#15b66d" : catColorMap[training.trainingProCategory];
                      temp.templateUrl = 'edit-training-popover.tpl.html';
                      temp.popOverPos = setPopoverPos(training.startTimeZulu);
                      toSend.push(temp);

                      prevTraining = training;
                      index++;
                    });
                    return toSend;
                }

                function getDummyRowFromOverlappingTrainings(trainingArr) {

                  var prevTraining;
                  var toSend = [];
                  var dummySend = [];
                  angular.forEach(trainingArr, function(training) {
                    var temp = training;
                    var assigned = false;

                    if (prevTraining != null) {

                      if (overlappingWithAnyTraining(toSend, training)) {
                        angular.forEach(dummySend, function (dummyArray) {
                          if (!assigned && !overlappingWithAnyTraining(dummyArray, training)) {
                            dummyArray.push(training);
                            assigned = true;
                          }
                        });
                        if (!assigned) {
                          var newDummy = [];
                          newDummy.push(training);
                          dummySend.push(newDummy);
                        }
                      }
                      else {
                        toSend.push(training);
                      }
                    }
                    else {
                      toSend.push(training);
                    }
                    prevTraining = training;

                  });
                  dummySend.splice(0, 0, toSend);
                  return dummySend;
                }

                function setPopoverPos(startTime){

                    return "right-top"
                }

                function getTimeInMinFromStartDate(checkInDate, checkInTime) {
                    var mo_checkIn = moment(checkInDate + ' ' + checkInTime, 'DD/MM/YYYY HH:mm');
                    var diffFromStart = mo_checkIn.diff(vm.da_start, 'm');
                    return Math.round(diffFromStart * vm.minuteToPixelRatio);
                }

                function filterDataByCategory(){
                    vm.minimumTopPosition = null;
                    var temp = getFilteredData();
                    if (temp.length > 0){
                        const hubWiseSortedData = _.sortBy(temp, 'crewHub');
                        vm.filteredData  = _.groupBy(hubWiseSortedData, 'catHubFilter');
                    }
                    var tempArray = [], i= 0, tottalWidth=0;
                    angular.forEach(vm.filteredData, function(catArray, catKey){
                        var itamArrays = getDummyRowFromOverlappingTrainings(catArray);
                        var isFirstRowOfcategory = true;
                        angular.forEach(itamArrays, function (item) {
                          tempArray.push({
                            width: 200,
                            leftPos: tottalWidth,
                            catLabel: catKey,
                            catItems: formatTraining(item),
                            isFirst: isFirstRowOfcategory
                          });
                          isFirstRowOfcategory = false;
                        });

                        tottalWidth += catArray.length * trainingWidth;
                        i++;

                    });

                    vm.filteredData = tempArray;

                    CreatePairing.setTrainingFilteredData(vm.filteredData);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEWPORT_DATA_CHANGE);
                    //scrollToMinimum();
                }

                function overlappingWithAnyTraining(trainingArray, training) {
                  var res = false;
                  angular.forEach(trainingArray, function (slot) {
                    if (isOverlapping(slot, training)) {
                      res = true;
                    }
                  });
                  return res;
                }

                function isOverlapping(training1, training2) {
                  var mo_checkIn_1 = moment(training1.startDateZulu + ' ' + training1.startTimeZulu, 'DD/MM/YYYY HH:mm');
                  var mo_checkOut_1 = moment(training1.endDateZulu + ' ' + training1.endTimeZulu, 'DD/MM/YYYY HH:mm');
                  var mo_checkIn_2 = moment(training2.startDateZulu + ' ' + training2.startTimeZulu, 'DD/MM/YYYY HH:mm');
                  var mo_checkOut_2 = moment(training2.endDateZulu + ' ' + training2.endTimeZulu, 'DD/MM/YYYY HH:mm');

                  if (mo_checkIn_1 <= mo_checkIn_2 && mo_checkIn_2 <= mo_checkOut_1) {
                    return true;
                  }
                  else if (mo_checkIn_1 <= mo_checkOut_2 && mo_checkIn_1 >= mo_checkIn_2) {
                    return true;
                  }
                  return false;
                }

              function renderTimeLine() {
                vm.viewMode = 'D';
                vm.timeLineData.length = 0;
                vm.dayLineData.length = 0;
                vm.scrollAreaWidth = 0;
                console.log(vm.screen_right_panel +" , " +vm.minimum_number_of_columns +" , "+ window.innerWidth );
                vm.columnWidthInPx = Math.floor((vm.screen_right_panel ) / vm.minimum_number_of_columns - 3);
                vm.minuteToPixelRatio = vm.columnWidthInPx / (60 * (vm.viewMode==='D'?1:24));

                var col_start = moment(vm.trainingData[0].startDateZulu, 'DD/MM/YYYY');
                vm.mo_start = col_start;
                vm.da_start = moment(vm.startDate, 'DD/MM/YYYY HH:mm');

                var columnGapBy = 'd';
                if (vm.viewMode == 'D') {
                  columnGapBy = 'h';
                }
                vm.actual_number_of_coulmns = 0;

                var columnCount = 0,displayFormat = "";

                if(vm.viewMode == 'D'){
                  vm.actual_number_of_coulmns = vm.displayParams.no_of_actual_hour_cols_per_day;
                  columnCount = vm.displayParams.no_of_actual_hour_cols_per_day;
                  displayFormat = "HH:mm";
                }

                vm.noOfDays = 1;
                if (vm.noOfDays-1===0) {//1 day data
                  if (vm.viewMode == 'D') {
                    vm.actual_number_of_coulmns = (vm.noOfDays === 0 ? 1 : vm.noOfDays) * vm.minimum_number_of_columns;
                    columnCount = vm.displayParams.no_actual_day_cols_per_month;
                    displayFormat = "HH:mm";
                  }
                }

                var tmp;
                for (var i = 0; i < 24; i++) {
                  col_start = moment(col_start).startOf('day');

                  tmp = moment(col_start).add(i, columnGapBy);
                  vm.timeLineData.push({
                    headerLabel:tmp.format(displayFormat),
                    dayOfWeekShort: tmp.format('DDD'),
                    date: tmp.format('DD/MM/YYYY'),
                    dateShort : tmp.format('DD/MM')
                  });
                  vm.scrollAreaWidth += vm.columnWidthInPx + 2;


                  if( i % columnCount === 0 ){
                    vm.dayLineData.push({
                      dayLabelWidth: vm.columnWidthInPx * columnCount,
                      dayLabel: tmp.format('DD/MM/YYYY'),
                      dayOfWeekShort: tmp.format('ddd')
                    });
                  }
                }

                vm.scrollAreaWidth += vm.screen_left_panel;

              }

            },
            bindings: {
                startDate: '<',
                programs:'<',
                programDetails:'<',
                noOfDays:'<',
                showInCrewPortal: '=',
                onSelectTraining: '&',
                onSelectProgram: '&',
                onAddTraining:'&',
                isRestRequired:'&'
            }
        }
    )
})();
